import { TurboModuleRegistry } from 'react-native';
let SherloModule = null;
try {
    SherloModule = TurboModuleRegistry.getEnforcing('SherloModule');
}
catch (e) {
    // Ignore if module is not found
}
export default SherloModule;
//# sourceMappingURL=NativeSherloModule.js.map